
      var $parcel$global = globalThis;
    
var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequiref040"];

if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequiref040"] = parcelRequire;
}

var parcelRegister = parcelRequire.register;
parcelRequire("kAAOE");

var $3ngNe = parcelRequire("3ngNe");
const $e201862501a0bd04$var$getPathName = ()=>{
    const arr = location.pathname.split("/").filter((item)=>!!item);
    return arr[arr.length - 1] ?? "";
};
(0, $3ngNe.default).data("category", ()=>$e201862501a0bd04$var$getPathName());
(0, $3ngNe.default).data("categoryList", ()=>[
        {
            key: "wire-draw-dies",
            title: "Wire Draw Dies",
            link: "/product-category/wire-draw-dies",
            results: 10
        },
        {
            key: "extrusion-tools-and-wire-guide",
            title: "Extrusion Tools And Wire Guide",
            link: "/product-category/extrusion-tools-and-wire-guide",
            results: 4
        },
        {
            key: "nail-dies",
            title: "Nail Dies",
            link: "/product-category/nail-dies",
            image: "https://starcarbide.com/wp-content/uploads/4-1.jpg",
            results: 3
        },
        {
            key: "tungsten-carbide-roll",
            title: "Tungsten Carbide Roll",
            link: "/product-category/tungsten-carbide-roll",
            results: 4
        },
        {
            key: "dies-for-fasteners",
            title: "Dies for fasteners",
            link: "/product-category/dies-for-fasteners",
            results: 10
        }
    ]);
const $e201862501a0bd04$var$productListMap = {
    "wire-draw-dies": [
        {
            title: "ND WIRE DRAWING DIE",
            link: "/product/nd-wire-drawing-die",
            image: "/images/1\u3001WIRE DRAW DIES/1\u3001ND WIRE DRAWING DIE .png"
        },
        {
            title: "PCD WIRE DRAWING DIE",
            link: "/product/pcd-wire-drawing-die",
            image: "/images/1\u3001WIRE DRAW DIES/2\u3001PCD WIRE DRAWING DIE.png"
        },
        {
            title: "TUNGSTEN CARBIDE WIRE DRAWING DIE",
            link: "/product/tungsten-carbide-wire-drawing-die",
            image: "/images/1\u3001WIRE DRAW DIES/3.TUNGSTEN CARBIDE WIRE DRAWING DIE.jpg"
        },
        {
            title: "Nano Coating Drawing Die",
            link: "/product/nano-coating-drawing-die",
            image: "/images/1\u3001WIRE DRAW DIES/4\u3001Nano Coating Drawing Die.png"
        },
        {
            title: "PCD Stranding Dies",
            link: "/product/pcd-stranding-dies",
            image: "/images/1\u3001WIRE DRAW DIES/5\u3001PCD Stranding Dies.png"
        },
        {
            title: "Sector Stranding Die",
            link: "/product/sector-stranding-die",
            image: "/images/1\u3001WIRE DRAW DIES/6\u3001Sector Stranding Die.png"
        },
        {
            title: "Tubing Dies",
            link: "/product/tubing-dies",
            image: "/images/1\u3001WIRE DRAW DIES/7\u3001Tubing Dies.png"
        },
        {
            title: "Special-shaped Dies",
            link: "/product/special-shaped-dies",
            image: "/images/1\u3001WIRE DRAW DIES/8\u3001Special-shaped Dies.png"
        },
        {
            title: "Split Stranding Dies",
            link: "/product/split-stranding-dies",
            image: "/images/1\u3001WIRE DRAW DIES/9 Split Stranding Dies.png"
        },
        {
            title: "ROLLER PRESSING DIE",
            link: "/product/roller-pressing-die",
            image: "/images/1\u3001WIRE DRAW DIES/10\u3001ROLLER PRESSING DIE.png"
        }
    ],
    "extrusion-tools-and-wire-guide": [
        {
            title: "Extrusion Tips",
            link: "/product/extrusion-tips",
            image: "/images/2\u3001Extrusion Tools And Wire Guide/56.png"
        },
        {
            title: "Extrusion Dies",
            link: "/product/extrusion-dies",
            image: "/images/2\u3001Extrusion Tools And Wire Guide/extursion-dies.png"
        },
        {
            title: "Lap Joint Mold",
            link: "/product/lap-joint-mold",
            image: "/images/2\u3001Extrusion Tools And Wire Guide/lap-joint-mold.png"
        },
        {
            title: "Spiral Diverter",
            link: "/product/spiral-diverter",
            image: "/images/2\u3001Extrusion Tools And Wire Guide/spiral-diverter.png"
        }
    ],
    "nail-dies": [
        {
            title: "Nail cutting knife",
            link: "/product/nail-cutting-knife",
            image: "/images/4\u3001nail dies/1\u3001Nail cutting knife.png"
        },
        {
            title: "Nail gripper die",
            link: "/product/nail-gripper-die",
            image: "/images/4\u3001nail dies/2\u3001Nail gripper die.png"
        },
        {
            title: "Nail head punch",
            link: "/product/nail-head-punch",
            image: "/images/4\u3001nail dies/3\u3001Nail head punch.jpg"
        }
    ],
    "tungsten-carbide-roll": [
        {
            title: "Tungsten carbide roller for welded wire mesh",
            link: "/product/tungsten-carbide-roller-for-welded-wire-mesh",
            image: "/images/3\u3001tungsten carbide roll/1\u3001Tungsten carbide roller for welded wire mesh.jpg"
        },
        {
            title: "ROLLER HOLDERS AND COLLING PINS",
            link: "/product/roller-holders-and-colling-pins",
            image: "/images/3\u3001tungsten carbide roll/2\u3001ROLLER HOLDERS AND COLLING PINS.png"
        },
        {
            title: "DESCALING ROLLS",
            link: "/product/descaling-rolls",
            image: "/images/3\u3001tungsten carbide roll/3.DESCALING ROLLS.png"
        },
        {
            title: "Seaming roller",
            link: "/product/seaming-roller",
            image: "/images/3\u3001tungsten carbide roll/4\u3001Seaming roller.png"
        }
    ],
    "dies-for-fasteners": [
        {
            title: "Flat Dies",
            link: "/product/flat-dies",
            image: "/images/5\u3001Dies for fasteners/1\u3001Flat Dies.jpg"
        },
        {
            title: "Cold heading dies",
            link: "/product/cold-heading-dies",
            image: "/images/5\u3001Dies for fasteners/2\u3001Cold heading dies.png"
        },
        {
            title: "Threading rolling dies",
            link: "/product/threading-rolling-dies",
            image: "/images/5\u3001Dies for fasteners/3\u3001Threading rolling dies.png"
        },
        {
            title: "Stamping dies",
            link: "/product/stamping-dies",
            image: "/images/5\u3001Dies for fasteners/4\u3001Stamping dies.png"
        },
        {
            title: "Trimming Dies",
            link: "/product/trimming-dies",
            image: "/images/5\u3001Dies for fasteners/5\u3001Cold Forming Trimming Die.png"
        },
        {
            title: "PUNCH CUTTER",
            link: "/product/punch-cutter",
            image: "/images/5\u3001Dies for fasteners/6\u3001PUNCH CUTTER.png"
        },
        {
            title: "MAIN DIES",
            link: "/product/main-dies",
            image: "/images/5\u3001Dies for fasteners/7\u3001MAIN DIES.png"
        },
        {
            title: "PUNCH",
            link: "/product/punch",
            image: "/images/5\u3001Dies for fasteners/8\u3001PUNCH.png"
        },
        {
            title: "TUNGSTEN CARBIDE DIES",
            link: "/product/tungsten-carbide-dies",
            image: "/images/5\u3001Dies for fasteners/9\u3001TUNGSTEN CARBIDE DIES.png"
        },
        {
            title: "Heading Dies",
            link: "/product/heading-dies",
            image: "/images/5\u3001Dies for fasteners/10\u3001Heading Dies.png"
        }
    ]
};
(0, $3ngNe.default).data("productList", ()=>$e201862501a0bd04$var$productListMap[$e201862501a0bd04$var$getPathName()]);
(0, $3ngNe.default).start();


//# sourceMappingURL=index.b4f9e087.js.map
